import { useState, useEffect } from "react";
import styles from "./styles.module.css";
import ActionEditor from "./actioneditor";
import ParamEditor from "./parameditor";
import usePan from "./usepan";
import Errors from "./errors";
export default function Editor({ selected, handleDelete }) {
  const [paramSources, setParamSources] = useState([]);
  const [zoom, setZoom] = useState(1);
  const [offset, startPan] = usePan();
  const [errorId, setErrorId] = useState(null);

  useEffect(() => {
    if (selected) {
      const paramSources = selected.params.map((p) => ({
        name: p.name,
        code: p.id,
        returnType: p.type,
        returnList: p.list,
        params: [],
      }));
      setParamSources(paramSources);
    }
  }, [selected]);

  const increase = () => {
    setZoom(zoom + 0.05);
  };

  const decrease = () => {
    setZoom(zoom - 0.05);
  };
  return (
    <div
      className={
        selected ? styles.editor + " " + styles.selected : styles.editor
      }
      onMouseDown={startPan}
    >
      {selected && (
        <ParamEditor handleDelete={handleDelete} workflow={selected} />
      )}
      {selected && (
        <div
          style={{
            position: "absolute",
            left: 0,
            top: 0,
            right: 0,
            bottom: 0,
            transform: `scale(${zoom}) translate(${-offset.x}px, ${-offset.y}px)`,
            transformOrigin: "center",
          }}
        >
          <ActionEditor
            sources={[...paramSources]}
            workflow={selected}
            errorId={errorId}
            setErrorId={setErrorId}
          />
        </div>
      )}
      <div style={{ position: "absolute", left: 15, bottom: 15 }}>
        <button className={styles.zoomButton} onClick={increase}>
          +
        </button>
        <button className={styles.zoomButton} onClick={decrease}>
          -
        </button>
      </div>
      <Errors setErrorId={setErrorId} />
    </div>
  );
}
